import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Reset window scroll on every client-side route change. */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search, hash]);

  return null;
}
